var DeviceManager = {};
DeviceManager.isAndroid = function() {
    var ua = navigator.userAgent;
    return ua.indexOf('android') !== -1 || ua.indexOf('Android') !== -1;
};
DeviceManager.isIos = function() {
    return DeviceManager.isIphone() || DeviceManager.isIpad();
};
DeviceManager.isIphone = function() {
    var ua = navigator.userAgent;
    return ua.indexOf('iPhone') !== -1;
};
DeviceManager.isIpad = function() {
    var ua = navigator.userAgent;
    return ua.indexOf('iPad') !== -1;
};
DeviceManager.isTablet = function() {
    var max = 1024;
    var biggestScreenSide = (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height;

    return (!DeviceManager.isDesktop() && biggestScreenSide >= max);
};
DeviceManager.isMobile = function() {
    var max = 1023;
    var biggestScreenSide = (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height;

    return (!DeviceManager.isDesktop() && biggestScreenSide <= max);
};
DeviceManager.isHandheld = function() {
    return (!DeviceManager.isDesktop() && (DeviceManager.isTablet() || DeviceManager.isMobile()));
};
DeviceManager.isDesktop = function() {
    return (!DeviceManager.touchAvailable && !window.orientation);
};
DeviceManager.touchAvailable = function() {
    return !!(("ontouchstart" in window) || (window.DocumentTouch && document instanceof window.DocumentTouch) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
}();

DeviceManager.isIe10 = function() {
    if(navigator.appVersion.indexOf('MSIE 10') !== -1) {
        return true;
    }

    return false;
};
DeviceManager.isIe11 = function() {
    var UAString = navigator.userAgent;
    if(UAString.indexOf('Trident') !== -1 && UAString.indexOf('rv:11') !== -1) {
        return true;
    }

    return false;
};

DeviceManager.isFirefox = function() {
    var ua = navigator.userAgent;
    return ua.indexOf('Firefox') !== -1;
};

DeviceManager.isEdge = function() {
    var ua = navigator.userAgent;
    return ua.indexOf('Edge') !== -1;
};

DeviceManager.isSafari = function() {
    var ua = navigator.userAgent.toLocaleLowerCase();

    if(ua.indexOf('safari') !== -1) { 
        if(ua.indexOf('chrome') > -1) {
            return false
        } 
        else {
            return true;
        }
    }

    return false;
};

DeviceManager.isChrome = function() {
    var ua = navigator.userAgent.toLocaleLowerCase();

    return ua.indexOf('chrome') !== -1;
};

export default DeviceManager;


// WEBPACK FOOTER //
// ./src/modules/DeviceManager.js